import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/home'
// import MapTest from '@/views/map_test'

Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '*',
      name: 'home',
      component: Home
    },
    {
      path: '/',
      name: 'home',
      component: Home
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js